import React from "react";

import "../OpenWindow/OpenWindow.css";
import "./VirtualDesktop.css";

import { Icon as MojaveIcon } from "../v2/icon/icon.tsx";
import Resume from "../Resume/Resume.jsx";
import OpenWindow from "../OpenWindow/OpenWindow.jsx";
import Fflickr from "../Fflickr/Fflickr.jsx";
import Penultimate from "../Penultimate/Penultimate.jsx";
import YayQuery from "../YayQuery/YayQuery.jsx";
import MackCali from "../MackCali/MackCali.jsx";
import Glados from "../Glados/Glados.jsx";
import ITunes from "../ITunes/ITunes.jsx";
import ReadMe from "../ReadMe/ReadMe.jsx";
import Fiddles from "../Fiddles/Fiddles.jsx";
import { Median } from "../Median/Median";
import { GameKeeper } from "../GameKeeper/GameKeeper";

import file from "../../assets/iconnew.png";
import itunes from "../../assets/iconmp3.png";
import ianresume from "../../assets/IDDMasterResume5_31_24.png";
import photobar from "../../assets/jpgbar.png";
import headshot from "../../assets/headshot.png";

export default class VirtualDesktop extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      resume: false,
      fflickr: false,
      penultimate: false,
      yayquery: false,
      mackcali: false,
      readme: true,
      itunes: false,
      fflickrReadme: false,
      penultimateReadme: false,
      yayqueryReadme: false,
      mackcaliReadme: false,
      photo: false,
      fiddles: false,
      contact: false,
      median: false,
      gamekeeper: false,
      medianReadme: false,
      gamekeeperReadme: false,
      test: false,
    };
    this.openFile = this.openFile.bind(this);
  }

  openFile(filename) {
    let files = [
      "fflickr",
      "penultimate",
      "yayquery",
      "mackcali",
      "fiddles",
      "median",
      "gamekeeper",
    ];
    if (files.includes(filename)) {
      this.setState({
        fflickr: false,
        penultimate: false,
        yayquery: false,
        mackcali: false,
        fflickrReadme: false,
        penultimateReadme: false,
        yayqueryReadme: false,
        mackcaliReadme: false,
        fiddles: false,
        median: false,
        gamekeeper: false,
        medianReadme: false,
        gamekeeperReadme: false,
        test: false,
      });
    }
    this.setState({ [filename]: true });
    console.log("open");
  }

  closeFile(filename) {
    this.setState({ [filename]: false });
  }

  render() {
    return (
      <div className="desktop-background">
        <div className="taskbar"></div>
        <div className="desktop-box">
          <div className="left-flex">
            <div id="readme-icon">
              <MojaveIcon
                extension="MD"
                imageSrc={file}
                text="README"
                open={() => this.openFile("readme")}
              />
            </div>
            {this.state.readme ? (
              <ReadMe
                close={() => this.closeFile("readme")}
                copy={[
                  <div>
                    <p>
                      &#9835; <u>Welcome to my Virtual Desktop</u> &#9834;
                    </p>
                    <p>
                      It's a fun way to learn more about me and my work and a
                      chance for me to show off my creativity and React chops.
                      You can dismiss this or any other open window by clicking
                      its close button in the top left corner, just like a real
                      desktop window!
                    </p>
                    <p>
                      <u>About Me:</u>
                    </p>
                    <p>
                      Hi, I'm Ian! I'm a full-stack developer whose interest and
                      talents skew towards the front-end. I'm also a passionate
                      Agile practitioner and former Agile consultant. I've been
                      lucky enough to work on some great teams and projects
                      which you can read up on by checking my resume (click the
                      resume icon to open it and then click the resume itself to
                      download).
                    </p>
                    <p>
                      I love working creatively as part of team, bouncing ideas
                      around and coming up with out of the box UI solutions.
                      Love to pair program.
                    </p>
                    <p>
                      In my spare time I do a lot of table-top gaming (board
                      games, D&D) with a great group of friends. I play video
                      games sometimes as well. Love a good long walk though this
                      great city of ours. Let grab some dim sum sometime!
                    </p>
                    <p>
                      If you'd like to get in touch (and I hope you will!) feel
                      free to npm install my contact info:
                    </p>
                    <p>
                      <strong>`$ npm i -g iandelduca`</strong>
                    </p>
                    <p>Otherwise, it's all on my resume!</p>
                    <p>Yours,</p>
                    <p>Ian Del Duca</p>
                  </div>,
                ]}
              />
            ) : null}

            <div id="resume-icon">
              <MojaveIcon
                extension="DOC"
                imageSrc={file}
                text="Resume"
                open={() => this.openFile("resume")}
              />
            </div>
            {this.state.resume ? (
              <OpenWindow
                cssId="resume-window"
                close={() => this.closeFile("resume")}
              >
                <Resume src={[ianresume]} />
              </OpenWindow>
            ) : null}

            <div id="fflickr-icon">
              <MojaveIcon
                folder
                text="Fflickr"
                open={() => this.openFile("fflickr")}
              />
            </div>
            {this.state.fflickr ? (
              <OpenWindow
                title="Fflickr"
                className="open-window-container"
                close={() => this.closeFile("fflickr")}
              >
                <Fflickr open={() => this.openFile("fflickrReadme")} />
              </OpenWindow>
            ) : null}
            {this.state.fflickrReadme ? (
              <ReadMe
                close={() => this.closeFile("fflickrReadme")}
                copy={[
                  <div>
                    <p>
                      Fflickr is a full-stack image sharing and hosting app
                      which emulates the core funtionality of Yahoo's Flickr.
                    </p>
                    <p>
                      Users can share, comment on, and tag photos in addition to
                      grouping them into albums.
                    </p>
                    <p>
                      It was built with Rails, utilizing PostgreSQL and serving
                      a restful JSON API on the backend, and React with a
                      normalized Redux state on the front end.
                    </p>
                    <p>
                      Images are hosted on AWS which is managed through use of
                      the Ruby Paperclip Gem. Images can be uploaded using
                      drag-and-drop through use of the Dropzone JavaScript
                      library.
                    </p>
                  </div>,
                ]}
              />
            ) : null}

            <div id="penultimate-icon">
              <MojaveIcon
                folder
                text="PenultimateFantasy"
                open={() => this.openFile("penultimate")}
              />
            </div>
            {this.state.penultimate ? (
              <OpenWindow
                title="Penult..."
                className="penultimate-container"
                close={() => this.closeFile("penultimate")}
              >
                <Penultimate open={() => this.openFile("penultimateReadme")} />
              </OpenWindow>
            ) : null}
            {this.state.penultimateReadme ? (
              <ReadMe
                close={() => this.closeFile("penultimateReadme")}
                copy={[
                  <div>
                    <p>
                      Penultimate Fantasy is a match-three 'candy-crush' style
                      game built for the browser. It uses the match-three
                      mechanic to help a group of heros defeat an enemy dragon.
                    </p>
                    <p>
                      <u>NB:</u> This game is <strong>NOT</strong> optimized for
                      drag and drop. In order to take a turn click the first
                      character you'd like to swap, and then click any adjacent
                      character.
                    </p>
                    <p>
                      A correct match decreases the dragons HP. If the player
                      can bring those HP down to zero within 20 turns, they win.
                      If not they face the dragon's wrath!
                    </p>
                    <p>
                      This game serves as a demo of my YayQuery.js Library, also
                      featured on this site. All DOM manipulation usually
                      designated for JQuery is exectuted by YayQuery.js instead.
                      I also used Animate.css to help smooth over the sprite
                      animations.
                    </p>
                  </div>,
                ]}
              />
            ) : null}

            <div id="yayquery-icon">
              <MojaveIcon
                folder
                text="YayQuery"
                open={() => this.openFile("yayquery")}
              />
            </div>
            {this.state.yayquery ? (
              <OpenWindow
                title="YayQuery.js"
                className="yayquery-container"
                close={() => this.closeFile("yayquery")}
              >
                <YayQuery open={() => this.openFile("yayqueryReadme")} />
              </OpenWindow>
            ) : null}
            {this.state.yayqueryReadme ? (
              <ReadMe
                close={() => this.closeFile("yayqueryReadme")}
                copy={[
                  <div>
                    <p>YayQuery.js!</p>
                    <p>
                      YayQuery.js! as the name suggests, is my self-authored
                      JavaScript library which emulates much of the
                      functionality of JQuery including the selection of DOM
                      elements, AJAX requests, and adding and removing classes
                      and event listeners.
                    </p>
                    <p>
                      You can see it in action by checking out the 'Penultimate
                      Fantasy' project below, which is written entirely in
                      YayQuery!
                    </p>
                  </div>,
                ]}
              />
            ) : null}

            <div id="mackcali-icon">
              <MojaveIcon
                folder
                text="Mack Cali"
                open={() => this.openFile("mackcali")}
              />
            </div>
            {this.state.mackcali ? (
              <OpenWindow
                id="mcwindow"
                title="Mack-Cali"
                className="mackcali-container"
                close={() => this.closeFile("mackcali")}
              >
                <MackCali open={() => this.openFile("mackcaliReadme")} />
              </OpenWindow>
            ) : null}
            {this.state.mackcaliReadme ? (
              <ReadMe
                close={() => this.closeFile("mackcaliReadme")}
                copy={[
                  <div>
                    <p>Mack-Cali 2018</p>
                    <p>
                      This is a site I developed in conjunction with Inc Design
                      group for the Mack-Cali Real Estate Corporation and it's
                      shareholders.
                    </p>
                    <p>
                      It's built entirely in React, and is fully-responsive
                      thanks to BootStrap 4. I also crafted several charts and
                      graphs to order using Chart.js, which uses canvas to
                      render and animate data visually when they appear on
                      screen.
                    </p>
                  </div>,
                ]}
              />
            ) : null}

            <div id="median-icon">
              <MojaveIcon
                folder
                text="Median"
                open={() => this.openFile("median")}
              />
            </div>
            {this.state.median && (
              <OpenWindow title="Median" close={() => this.closeFile("median")}>
                <Median open={() => this.openFile("medianReadme")}></Median>
              </OpenWindow>
            )}
            {this.state.medianReadme && (
              <ReadMe
                close={() => this.closeFile("medianReadme")}
                copy={
                  <div>
                    <p>Median</p>
                    <p>Media that matters... to Ian (That's Me)</p>
                    <p>
                      Median was built as a simple blogging application which
                      cribs heavily in its functionality and design from
                      Medium.com. It is my own personal blog so only I can post
                      content, but users can log-in to take advantage of the
                      commenting and "clapping" functionality avaiable on each
                      post.
                    </p>
                    <p>
                      I always say this but... I need to get more content up
                      there.
                    </p>
                  </div>
                }
              />
            )}

            <div id="gamekeeper-icon">
              <MojaveIcon
                folder
                text="GameKeeper"
                open={() => this.openFile("gamekeeper")}
              />
            </div>
            {this.state.gamekeeper && (
              <OpenWindow
                title="GameKeeper"
                close={() => this.closeFile("gamekeeper")}
              >
                <GameKeeper
                  open={() => this.openFile("gamekeeperReadme")}
                ></GameKeeper>
              </OpenWindow>
            )}

            {this.state.gamekeeperReadme && (
              <ReadMe
                close={() => this.closeFile("gamekeeperReadme")}
                copy={
                  <div>
                    <p>Gamekeeper</p>
                    <p>
                      A social media experiment of mine conceived to help log
                      video games played in order to facilitate Game of the Year
                      discussion keeping the full breadth of one's gaming
                      experience that year in mind
                    </p>
                    <p>
                      You can add and track the games your playing, the hours
                      you've played each as well as follow your friends to see
                      what they're playing. Feel free to log-in as a guest and
                      click around.
                    </p>
                    <p>
                      The design attempts to utilize the visual language of old
                      8bit NES games, specifically Super Mario Bros.
                    </p>
                  </div>
                }
              />
            )}
          </div>

          {
            // LEFT <-------> RIGHT
          }

          <div className="right-flex">
            <div id="fiddle-icon">
              <MojaveIcon
                folder
                text="Fiddles"
                open={() => this.openFile("fiddles")}
              />
            </div>
            {this.state.fiddles ? (
              <OpenWindow
                title="Fiddles"
                close={() => this.closeFile("fiddles")}
              >
                <Fiddles />
              </OpenWindow>
            ) : null}

            <div id="jpg-icon">
              <MojaveIcon
                imageSrc={headshot}
                text="me.jpg"
                open={() => this.openFile("photo")}
              />
            </div>
            {this.state.photo ? (
              <div className="photo-container">
                <div
                  className="close-button"
                  onClick={() => this.closeFile("photo")}
                ></div>
                <img className="photobar" src={photobar} />
                <img className="headshot" src={headshot} />
              </div>
            ) : null}

            <div id="glados-icon">
              <MojaveIcon
                extension="EXE"
                imageSrc={file}
                text="GLaDoS"
                open={() => this.openFile("glados")}
              />
            </div>
            {this.state.glados ? (
              <div id="glados-window">
                <Glados close={() => this.closeFile("glados")} />
              </div>
            ) : null}

            <div id="itunes-icon">
              <MojaveIcon
                imageSrc={itunes}
                text="chairlift .mp3"
                open={() => this.openFile("itunes")}
                extension="MP3"
              />
            </div>
            {this.state.itunes ? (
              <ITunes close={() => this.closeFile("itunes")} />
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}

/* old contact icon which display deprecated business card */
/* <div id='contact-icon'>
  <Icon fileName='contact' img={mail} open={() => this.openFile('contact')}/>
</div>
{
  this.state.contact ?
  <div className='photo-container' id="bcard">
      <div className='close-button' onClick={() => this.closeFile('contact')}></div>
      <img className='photobar' src={photobar} />
    <a href='mailto:ianmdelduca@gmail.com'>
      <img className='headshot' src={bcard} />
    </a>
  </div> : null
} */
